/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/button/custom-elements';

import { defineCustomElement as defineOsdsButton } from '@ovhcloud/ods-stencil/components/button/custom-elements/osds-button.js';


export const OsdsButton = /*@__PURE__*/ defineContainer<JSX.OsdsButton>('osds-button', defineOsdsButton, [
  'color',
  'contrasted',
  'disabled',
  'download',
  'flex',
  'href',
  'rel',
  'size',
  'target',
  'type',
  'variant',
  'circle'
]);

